import { DialogShared } from './../../general/shared/dialog-shared';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-predefined-diet-dialog',
  templateUrl: './predefined-diet-dialog.component.html',
  styleUrls: ['./predefined-diet-dialog.component.scss'],
})
export class PredefinedDietDialogComponent implements OnInit {
  title = '';
  description = '';
  notShowAgain = false;

  constructor(
    private dialogShared: DialogShared,
    private dialogref: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    console.log(this.data.dietType);

    this.description =
      'در برنامه غذایی ' +
      this.data.dietType.name +
      ' شما تنها باید از پکیج‌های غذایی پیشنهادی استفاده کنید.' +
      ' در غیر اینصورت شما به هدف مورد نظر خود نمی‌رسید.' +
      ' برای استفاده از امکانات ویرایش وعده پیشنهاد میکنیم رژیم شخصی سازی شده دریافت کنید.';
    switch (this.data.action) {
      case 'add': {
        this.title = 'افزودن غذای جدید';
        break;
      }
      case 'remove': {
        this.title = 'حذف غذا';
        break;
      }
      case 'edit': {
        this.title = 'ویرایش وعده';
        break;
      }
    }
  }

  ngOnInit() {}

  onContinue() {
    switch (this.data.action) {
      case 'add': {
        this.dialogShared.addFoodContinueButtonClick();
        break;
      }
      case 'remove': {
        this.dialogShared.removeFoodContinueButtonClick();
        break;
      }
      case 'edit': {
        this.dialogShared.editFoodContinueButtonClick();
        break;
      }
    }
    this.dialogref.close();
  }

  onChangePlan() {
    this.dialogShared.changePlanClick();
    this.dialogref.close();
  }

  onRejectAction() {
    this.dialogref.close();
  }

  changeShowStatus() {
    this.notShowAgain = !this.notShowAgain;
    if (this.notShowAgain) {
      localStorage.setItem('predefined-diet-dialog', '1');
    } else {
      localStorage.setItem('predefined-diet-dialog', '0');
    }
  }
}
